import { API_CONFIG } from '@/utils/api';

export function buildChapterPagesJsonUrl(capitulo: any): string | null {
    const obraId = capitulo?.obra?.id ?? capitulo?.obra?.obr_id;
    const uuid = capitulo?.cap_uuid ?? capitulo?.uuid;
    const num = capitulo?.cap_num ?? capitulo?.numero;
    if (obraId == null || !uuid || num == null) return null;
    const segment = String(num).replace('.', '_');
    return `${API_CONFIG.CDN_URL}/obras/${obraId}/capitulos/${segment}/${uuid}.json`;
}

export async function fetchChapterPagesArray(capitulo: any): Promise<any[]> {
    const jsonUrl = buildChapterPagesJsonUrl(capitulo);
    if (!jsonUrl) return [];
    try {
        const res = await fetch(jsonUrl, { cache: 'no-store' });
        if (!res.ok) return [];
        const payload = await res.json();
        return Array.isArray(payload) ? payload : [];
    } catch {
        return [];
    }
}

export function pageEntryToSrc(pagina: any): string | null {
    if (pagina && typeof pagina.url === 'string') {
        const u = pagina.url.trim();
        if (!u) return null;
        if (u.startsWith('http://') || u.startsWith('https://')) return u;
        const path = u.replace(/^\/+/, '');
        return `${API_CONFIG.CDN_URL}/${path}`;
    }
    return null;
}
